import React from 'react';
import request from 'arcdynamic-request';
import {AGENTS} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { ApolloConsumer } from '@apollo/client';
import { GET_AGENTS } from '../Graphql/queries';
import { GetOldResponse } from '../ResponseConversion/GetOldResponse';
import { fetchData } from '../Service/graphQlService';
import { GET_CONTACT_AGENTS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectAgent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
        this.client = null;
    }

    componentDidMount() {
        if(this.client){
        this.fetch(0);
        }
    }

    fetch(offset) {
        // request(arc.path.api, {
            // service: 'arcimedes',
            // action: 'open.datasource.table.Data.getData',
            // params: ['code', AGENTS, {
            //     limit: {
            //         count: limit,
            //         offset: offset * limit,
            //     },
            //     column: [
            //         'ARCIMEDES_ROW_ID',
            //         'FIRST_NAME',
            //         'LAST_NAME',
            //         'FIRM'
            //     ],
            //     filter: [
            //         {
            //             code: 'FIRST_NAME',
            //             text: '',
            //             type: 'notNull',
            //         },
            //         {
            //             code: 'DELETED',
            //             text: '',
            //             type: 'null',
            //         },
            //     ],
            //     filterType: 'and',
                // order: [
                //     {
                //         code: 'FIRST_NAME',
                //         type: 'asc',
                //     },
                //     {
                //         code: 'LAST_NAME',
                //         type: 'asc',
                //     },
                // ],
            // }],
            var pageParams = {
                page: null,
                pageSize: null
            }
            const order = [{
                field: 'FIRST_NAME',
                order: 'asc',
            },
            {
                field: 'LAST_NAME',
                order: 'asc',
            }
        ];
            // const token = localStorage.getItem('authToken');
            // this.client.query({
            //     query: GET_AGENTS, variables: {pageOptions:pageParams,sortOptions:order},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // })
                fetchData(GET_CONTACT_AGENTS_LIST_QUERY, { type: "Agent",pageOptions:pageParams,sortOptions:order})
       .then(res => {
            this.setState(prevState => {
                const data = res.data.getContacts.data.filter(item => item.first_name !== '' || item.last_name !== '')
                const items = prevState.items.concat(data);
                return {
                    items,
                };
            });
            // if (res.data.length >= limit) {
            //     this.fetch(++offset);
            // }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newAgent !== nextProps.newAgent) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newAgent);
            this.setState({items});
        }
    }

    render() {
        const { items } = this.state;
        const { 
            theme, 
            value, 
            valueKey, 
            label, 
            disabled, 
            data, 
            withAddNew,
            handleParentChange, 
            handleInputParentChange,
            isFilter, 
            viewMode,
            addNewItem,
            deleted,
            hasAgentPercent,
            isFromProperty,
            ...rest
        } = this.props;

        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <Dropdown theme={theme}
                      optionsType='agent'
                      optionKey='arcimedes_row_id'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      handleParentChange={handleParentChange}
                      handleInputParentChange={handleInputParentChange}
                      withAddNew={withAddNew}
                      viewMode={viewMode}
                      deleted={deleted}
                      addNewItem={addNewItem}
                      hasAgentPercent={hasAgentPercent}
                      isFromProperty={isFromProperty}
                      {...rest}
            />
        )
    }}

</ApolloConsumer>
        )
    }
}

SelectAgent.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    handleInputParentChange: PropTypes.func,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectAgent;
